/// <reference path="../../_Ext/Editors/BOMGridEditor.ts" />

namespace TabAurous.Inventory {
    import fld = BranchInBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class BranchInBOMEditor extends _Ext.BOMGridEditor<BranchInBOMRow> { 
        protected getDialogType() { return BranchInBOMDialog; }
        protected getLocalTextPrefix() { return BranchInBOMRow.localTextPrefix; }
         

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));           
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }
 
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}